module.exports = __webpack_public_path__ + "static/Tiger-2e1ef7a28b6e68545d967805b2860d48.jpg";